import apiClient from './client'

export interface SyncStatusItem {
  entidade: string
  qtd_auth: number
  qtd_tenant: number
  sincronizado: boolean
}

export interface SyncStatusResponse {
  empresa_id: number
  banco_dados?: string
  status_entidades: SyncStatusItem[]
}

export interface CopiarPadroesRequest {
  empresa_id: number
  entidades: string[]
  modo_sobrescrever: boolean
}

export interface EntidadeResult {
  lidos: number
  inseridos: number
  atualizados: number
  erros: string[]
}

export interface CopiarPadroesResponse {
  success: boolean
  empresa_id: number
  banco_dados?: string
  mensagem: string
  resultados: Record<string, EntidadeResult>
}

export const adminSyncApi = {
  getSyncStatus: async (empresaId: number): Promise<SyncStatusResponse> => {
    const response = await apiClient.get<SyncStatusResponse>(`/v1/admin/sync/status/${empresaId}`)
    return response.data
  },

  copiarPadroesTenant: async (payload: CopiarPadroesRequest): Promise<CopiarPadroesResponse> => {
    const response = await apiClient.post<CopiarPadroesResponse>('/v1/admin/sync/copiar-padroes', payload)
    return response.data
  },
}
